
<div class="d-flex justify-content-center loader flex-column align-items-center" *ngIf="loading">
    <div>
        <mat-spinner color="accent"></mat-spinner>
    </div>
</div>

<div *ngIf="!loading" class="row p-3 m-0 justify-content-center scrollable">
    <div class="col-md-3 p-3">
        <h1 class="mb-0">Account</h1>
        <p class="mb-0">{{currentUser?.Name}} {{currentUser?.Surname}}</p>
        <p class="text-primary">{{currentUser?.Email}}</p>
        <button class="text-left btn-block" routerLinkActive="active" routerLink="profile" mat-stroked-button>Profile</button>
        <button class="text-left btn-block" routerLinkActive="active" routerLink="settings" mat-stroked-button>Settings</button>
        <!-- <button routerLink="" mat-stroked-button>Password Management: Change password and set up two-factor authentication.</button> -->
        <button class="text-left btn-block" routerLinkActive="active" routerLink="security" mat-stroked-button>Security</button>
        <!-- <button class="btn-block" routerLinkActive="active" routerLink="notifications" mat-stroked-button>Notifications Preferences</button> -->
        <!-- <button routerLink="" mat-stroked-button>Email Notifications: Customize preferences for receiving marketing updates, newsletters, and alerts.</button>
        <button routerLink="" mat-stroked-button>SMS Notifications: Opt-in or opt-out of text message alerts.</button> -->
        <button class="text-left btn-block" routerLinkActive="active" routerLink="account" mat-stroked-button>Subscriptions</button>
        <!-- <button routerLink="" mat-stroked-button>Subscription Plans: View current plan, upgrade/downgrade subscription, and payment history.</button> -->
        <!-- <button routerLink="" mat-stroked-button>Payment Methods: Add, update, or remove credit card and payment details.</button> -->
        <h1 class="mt-5">My Business</h1>
        <button class="text-left btn-block" *ngFor="let business of businesses" routerLinkActive="active" routerLink="marketing" mat-stroked-button (click)="openBusinessmarketing(business)">{{ business.Name }}</button>
        
        <!-- <button routerLink="" mat-stroked-button>Ad Settings: Configure ad preferences, targeting options, and budget limits.</button> -->
        <!-- <button routerLink="" mat-stroked-button>Analytics: View and customize marketing analytics dashboards, reports, and performance metrics.</button> -->
    </div>
    <div class="col-md-9">
       <router-outlet></router-outlet>     <!-- <app-business-profile *ngIf="user" [profile]="user" (emitProfile)="loadProfile($event)" ></app-business-profile> -->
    </div>

</div>
